// Constants
export const SHOW_TOASTER_MESSAGE = "SHOW_TOASTER_MESSAGE";
export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_SHOW_STUDENT_DETIALS_IN_MOBILE =
	"SET_SHOW_STUDENT_DETIALS_IN_MOBILE";

export const showToasterMessage = (message = null, toasterColor = null) => {
	return (dispatch) => {
		dispatch({
			type: SHOW_TOASTER_MESSAGE,
			payload: {
				message,
				toasterColor,
			},
		});
	};
};

export const setIsLoading = (isLoading) => {
	return (dispatch) => {
		dispatch({
			type: SET_IS_LOADING,
			payload: isLoading,
		});
	};
};

export const setShowStudentDetailsInMobile = (showStudentDetailsInMobile) => {
	return (dispatch) => {
		dispatch({
			type: SET_SHOW_STUDENT_DETIALS_IN_MOBILE,
			payload: showStudentDetailsInMobile,
		});
	};
};
